import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';
import ExternalLink from 'components/Widgets/ExternalLink';

import IconWithText from 'components/Widgets/IconWithText';

export default function TitleAndActions({ program }) {
  return (
    <Row className="mb-3">
      <Col xl={8}>
        <h1>{program.attributes.title}</h1>
      </Col>

      <Col xl={4} className="mt-3 mt-xl-0 text-xl-end">
        <Link
          to={routes.members.programs.program.share}
          className="btn btn-outline-icon me-3 btn-outline-primary"
        >
          <IconWithText
            iconClassName="small-icon share-icon"
          />
        </Link>

        <ExternalLink
          className="btn-icon btn btn-primary"
          href={routes.members.programs.download(program.id)}
        >
          <IconWithText
            iconClassName="small-icon download-icon bg-white"
          />
        </ExternalLink>
      </Col>
    </Row>

  );
}

TitleAndActions.propTypes = {
  program: PropTypes.object.isRequired,
};
